/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CsvExport(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CsvExport',
      'aria-hidden': true,
      focusable: false,
      width:  15 * scale,
      height: 15 * scale,
      viewBox: '0 0 15 15',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M12 11h2.5L11 15l-3.5-4H10V5h2zM0 5h8v1H0zm0 3h8v1H0zm0 3h6v1H0zm0-9h12v1H0z","fill":"currentColor"}))
}
